import React, { Component } from "react";
import AntdBackTop, {BackTopProps} from 'antd/lib/back-top';
import 'antd/lib/back-top/style';

export default class BackTop extends Component<BackTopProps> {
    render() {
        return (
          <AntdBackTop {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/back-top/index.tsx